<template>
  <div>
    <div class="row" v-if="availableDurations.length > 0">
      <div class="col-12">
        <div class="form-group">
          <div
            class="custom-control custom-radio custom-control-inline"
            v-for="(item, key) in durations"
            :key="key"
            v-if="
              item.rate_period_id !== 8 &&
                availableDurations.includes(item.rate_period_id)
            "
          >
            <input
              @change="durationChange(item.rate_period_id)"
              type="radio"
              :value="item.rate_period_id"
              v-model="cDurationDefault"
              class="custom-control-input"
              :id="'duration' + group + key"
              :name="'products[' + group + '][duration]'"
            />
            <label
              class="custom-control-label"
              :for="'duration' + group + key"
              >{{ item.name[lang] }}</label
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "DurationWidget",
  props: ["group", "product", "index"],
  data() {
    return {
      availableDurations: [0]
    };
  },
  computed: {
    ...mapState({
      suppliers() {
        return this.form.data.fields[this.index].filter(
          x => x.type === "suppliers" && x.group === this.group
        )[0];
      },
      defaultDurations: state => state.forms.defaultDurations
    }),
    cDurationDefault: {
      get() {
        return this.form.data.fields[this.index].filter(
          x => x.type === "duration" && x.group === this.group
        )[0].default;
      },
      set(val) {
        let arr = this.form.data.fields[this.index].filter(
          x => x.type === "duration" && x.group === this.group
        )[0];
        arr.default = val;
        this.defaultDurations[arr.product] = val;
      }
    }
  },

  created() {
    this.suppliersVisible(this.suppliers.suppliers, 2, this.group);
    this.setDurations();
  },
  methods: {
    durationChange(rate_period_id) {
      let suppliers = [];
      suppliers = this.suppliers.suppliers;
      suppliers.animate = 1;
      this.suppliersVisible(suppliers, rate_period_id, this.group);
      //this.suppliers.default = suppliers.filter(x => x.disabled === 0)[0].id;
    },
    setDurations() {
      let suppliers = this.suppliers.suppliers;
      if (
        this.group === "internet" ||
        this.group === "mobile" ||
        this.group === "bankaccount"
      ) {
        this.availableDurations = [];
      }
      suppliers
        .filter(x => x.show === 1)
        .forEach(item => {
          if (Array.isArray(item.rate_period)) {
            Object.values(item.rate_period).forEach(p => {
              if (!this.availableDurations.includes(p) && p !== 0) {
                this.availableDurations.push(p);
              }
            });
          } else {
            if (!this.availableDurations.includes(item.rate_period)) {
              this.availableDurations.push(item.rate_period);
            }
          }
        });

      let currentDuration = this.form.data.fields[this.index].filter(
        x => x.type === "duration" && x.group === this.group
      )[0].default;
      if (!this.availableDurations.includes(currentDuration)) {
        this.form.data.fields[this.index].filter(
          x => x.type === "duration" && x.group === this.group
        )[0].default = this.availableDurations.includes(2)
          ? 2
          : this.availableDurations[0];
      }
    }
  },
  watch: {
    suppliers: {
      handler: function() {
        this.setDurations();
      },
      deep: true
    },
    cDurationDefault: function(newV) {
      let ary = this.form.data.fields[this.index].filter(
        x => x.type === "duration" && x.group === this.group
      )[0];
      this.defaultDurations[ary.product] = newV;
    }
  }
};
</script>
